module.exports = __webpack_public_path__ + "img/262.f6cc523e.jpg";